import { View } from 'backbone';
import listService from 'ListService.js';
import _ from 'lodash';
import $ from 'jquery';
import constants from 'Constants.js';
import eventBus from 'EventBus.js';
import template from 'common-views/select-field/select-field-modal.ejs';
import pageTemplate from 'common-views/select-field/select-field-page.ejs';
import controlWithValuesTemplate from 'common-views/select-field/select-field-control-with-values.ejs';
import controlTemplate from 'common-views/select-field/select-field-control.ejs';
import util from 'util/Util.js';

class SelectFieldModalView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.mode = opts.mode ? opts.mode : '';
        this.target = opts.target? opts.target : '';
        this.pageShiftArray = [];
        this.pages = undefined;

        this.events = {
            'click a.select-field': 'showList'
        };
        var pageObjects = [];

        this.dialogClass = "no-close";
        if (this.mode === 'objects' || this.mode === 'lists' || this.mode === 'objectsANDlists') {
            this.model.set('selectFieldTitle','Select Object',{silent: true} );
            let inputFilter = (control) => {
                return (control !== undefined && control.groupId === undefined);
            };
            pageObjects = listService.getAllControlsByPageList(inputFilter, false, this.mode);
        } else if (this.mode === 'behaviors') {
            this.model.set('selectFieldTitle','Select a Behavior',{silent: true} );
            pageObjects = listService.getAllBehaviorInstancesByPageList();
        } else {
            if (!opts.modalTitle) {
                this.model.set('selectFieldTitle','Select Field',{silent: true} );
            } else  {
                this.model.set('selectFieldTitle', opts.modalTitle, {silent: true} );
                this.dialogClass = "no-close small-title";
            }
            let inputFilter = this.selectInputFilter();
            pageObjects = listService.getAllControlsByPageList(inputFilter, true);
        }

        this.model.set('pages', pageObjects );

        return this;
    }

    selectInputFilter() {
        let inputFilter;
        switch (this.mode) {
            case 'insert':
                inputFilter= (control) => {
                    return (
                        control.subfamily === constants.CONTROL_ATTACHMENTS
                    );
                };
                break;
            case'print':
                inputFilter= (control) => {
                    return ( false );
                };
                break;
            case 'instance':
                inputFilter= (control) => {
                    return (
                        (control.family === constants.CONTROL_COMMON_INPUTS ||
                        control.family === constants.CONTROL_ADVANCED_INPUTS ||
                        control.subfamily ===  constants.CONTROL_INSTANCE) &&
                        control.options.factoryKey !== 'control_websignature' &&
                        control.options.factoryKey !== 'control_table'
                        &&  control.groupId === undefined
                    );
                };
                break;
            case 'insertField':
                inputFilter= (control) => {
                    return (
                        (control.family === constants.CONTROL_COMMON_INPUTS ||
                        control.family === constants.CONTROL_ADVANCED_INPUTS ||
                        control.subfamily ===  constants.CONTROL_INSTANCE) &&
                        control.options.factoryKey !== 'control_websignature' &&
                        control.groupId === undefined
                    );
                };
                break;
            case 'file':
                inputFilter= (control) => {
                    return (
                        control.subfamily === constants.CONTROL_ATTACHMENTS
                    );
                };
                break;
            default:
                inputFilter= (control) => {
                    // PF-6558 Unable to select Timer in behaviors
                    return (
                        (control.family === constants.CONTROL_COMMON_INPUTS ||
                        control.family === constants.CONTROL_ADVANCED_INPUTS ||
                        control.options.factoryKey === 'control_timer') && control.groupId === undefined
                    );
                };
                break;
        }
        return inputFilter;
    }

    showList(e) {
        e.preventDefault();

        let selItem = e.target;

        if ($(selItem).hasClass('fa')){
            selItem = $(selItem).parent()[0];
        }
        
        const target = selItem.getAttribute('data-target');

        if (target) {
            const key = selItem.getAttribute('data-selected-key');
            const targetText = selItem.text ? selItem.text.trim() : '';

            const controlListSelector = constants.SELECT_FIELD_ID + ' .control-list.' + target;
            const pageListSelector = constants.SELECT_FIELD_ID + ' .page-list.' + target;

            // PF-3953 conditional delegate to itemClicked(); SetField modal can pass a group caption OR toggle its subtree!
            // ==> Clicked a group name, but not it's toggle? Then we're selecting a group, not toggling it.
            // ==> In that case both group items' class becomes 'field-select selected'
            // A reset selection removes only the class 'selected', which is sufficient.
            // TODO Three identical DOM IDs! They're supposed to be UNIQUE on the page. Causing us to jump through hoops to distinguish DOM elmeents here.
            // We differentiate duplicate OOM IDs by a data-kind attribute added to the template.

            // Always reset all group selections. Simple item selections reset conditionally downstream by itemClicked(e)
            $("a[data-selected-key='control_group']").removeClass('selected');

            if (key === 'control_group' && !selItem.className.includes('glyph')){
                // Clicked the group name, not the toggle. Select the name; don't flip the toggle.
                // Clicking the toggle glyph won't enter here, so we're okay.
                window.setTimeout( () => {
                    this.itemClicked(e);
                    const domId = `${selItem.getAttribute('id')}`;
                    $(`#${domId}[data-kind='toggle'], #${domId}[data-kind='label']`)
                        .removeClass('field-list-toggle')
                        .addClass('field-select selected');
                }, 0);
            }
            else {

                $(pageListSelector).toggleClass('open-list');
                if(!(this.mode && this.mode === "print"))
                {
                    $(controlListSelector).slideToggle();
                }

                if (_.includes(['objects', 'print', 'objectsANDlists', 'instance', 'insertField'], this.mode)) {

                    let item = {
                        id: listService.getCleanedId(target),
                        name: targetText,
                        key: key
                    };

                    if (this.model.get('multipleSelectionEnabled')) {
                        let itemArray = this.model.get('selected');
                        //When we select a new item if these keys are not pressed the array must be cleaned if not it will have
                        //other elements clicked before
                        if (!(e.shiftKey || e.metaKey || e.ctrlKey)) {
                            itemArray = [];
                        }

                        let existItemOnModel = false;
                        if (!itemArray) {
                            itemArray = [];
                        } else {
                            if (itemArray.find((x) => x.id === item.id)) {
                                existItemOnModel = true;
                            }
                        }

                        if (!existItemOnModel) {
                            itemArray.push(item);
                        }

                        if (!(e.shiftKey || e.metaKey || e.ctrlKey)) {
                            $('a.field-select').removeClass('selected');

                            if(this.mode === "print"){
                                $('li.page-list').removeClass("selected")
                            }
                        }

                        this.model.set('selected', itemArray, {silent: true});

                    } else {
                        if (this.mode !== 'objects') {
                            this.model.set('selected', item, {silent: true});
                         
                            $('a.field-select').removeClass('selected');
                        }

                    }
                    if (this.mode !== 'objects') {

                        $('[data-target="' + target + '"]').addClass('field-select selected');    
                        
                        if(this.mode === "print"){
                            $('[data-target="' + target + '"]').parent().addClass("selected")
                        }                    

                        if (this.target === 'command_set_table_rows') {
                            $('button.btn-select-field').button(key !== 'control_table' ? "disable" : "enable");
                        } else if (key === 'page_instance' && (this.target === 'notifications' || this.mode === "instance")) {
                            $('button.btn-select-field').button("disable");
                        } else {
                            $('button.btn-select-field').button("enable");
                        }
                    }

                }
            }
        }
    }

    closeModal() {        
        listService.isUndoRedoEnabled = true;
        $(constants.SELECT_FIELD_ID).remove();
    }

    updateSelectedWithPageArray(selectedPages){
        let itemArray = [];
        function addArrayElement(arr){
            const 
                    selectedKey  = arr[0].getAttribute('data-selected-key'),
                    selectedId  = arr[0].getAttribute('data-target'),
                    selectedText = arr[0].text.trim();

            if(itemArray.filter(b => b.name && b.name ===selectedText).length === 0)
            {
                itemArray.push({
                    "id": selectedId,
                    "key": selectedKey,
                    "name": selectedText
                });
            }
        }
        selectedPages.forEach(item =>
        {
            if(item.length == 1)
            {
                addArrayElement(item);
            }
            else if(item.length > 0)
            {
                let tempArr = [...item].filter(z => z.text.trim() !== '');
                if(tempArr.length == 1)
                {
                    addArrayElement(tempArr);
                }
            }
        });

        this.model.set('selected', itemArray, { silent: true });
        this.pageShiftArray = [];
    }

    itemClicked(e){
        let item = e.target;
        // Always reset all group selections.
        $("a[data-selected-key='control_group']").removeClass('selected');

        if ($(item).hasClass('fa')){
            item = $(item).parent()[0];
        }

        const
            selectedItem = item.getAttribute('data-selected-item'),
            selectedName = item.getAttribute('data-selected-name'),
            selectedKey  = item.getAttribute('data-selected-key'),
            selectedId  = item.getAttribute('id');

        item.class = 'selected';

        if(this.mode === 'lists'){
            const
                listFactoriesMap = {'control_list':true, 'control_drop_down':true, 'control_ranking':true},
                control = listService.getObject(selectedItem),
                factoryKey = control.model.get('factoryKey');
            //if it's not on the allowed factories abort
            if(! listFactoriesMap[factoryKey]){
                return;
            }

        }

        if(selectedItem){
            let multiSelectionKeyPressed;
            if (e.metaKey || e.ctrlKey||this.model.get('manualMultipleSelectionEnabled')) {
                multiSelectionKeyPressed = 'ctrl';
            }else if (e.shiftKey){
                multiSelectionKeyPressed = 'shift';
            }
            this.selectItem(selectedItem, selectedName, selectedKey, selectedId, multiSelectionKeyPressed);
        }
    }

    selectItem(selectedItem, selectedName, selectedKey, selectedId, multiSelectionKeyPressed){
        const selectedDOMID = '#' + selectedId;

        let newId = listService.getCleanedId(selectedItem); 

        $('.selectedGroup').removeClass('selectedGroup');
        
        // If selectedItem contains $v, strip it and find original id then add it back
        if (selectedItem.indexOf('$v') !== -1) {
            newId = listService.getCleanedId(selectedItem.replace('$v', '')) + '$v';
        }

        let item = { id: newId, name: selectedName, key: selectedKey };
        if (this.model.get('multipleSelectionEnabled') && multiSelectionKeyPressed) {
            let itemArray = this.model.get('selected');            
            let existItemOnModel = false;
            if (!itemArray) {
                itemArray = [];
            } else {
                if (Array.isArray(itemArray) && itemArray.find((x) => x.id === item.id)) {
                    existItemOnModel = true;
                }
            }

            if (Array.isArray(itemArray) && !existItemOnModel) {
                itemArray.push(item);
            }

            if (multiSelectionKeyPressed === 'ctrl' || itemArray.length <= 1){
                var selectedItem = $('#select-field-dialog ' + selectedDOMID);
                selectedItem.toggleClass('selected');
                selectedItem.parent().toggleClass('control-list-container selected');
            } else {
                $('.selected').removeClass('control-list-container selected');
                $('a.field-select').removeClass('selected');
                let limitsCount = 0; //Will count to two, one for inferior limit and another for superior limit
                let newArray = [];
                $('a.field-select').each(function (index, _itemSelected) {
                    if (limitsCount < 2) {
                        if ($(_itemSelected).data('selectedItem') === item.id || $(_itemSelected).data('selectedItem') === itemArray[itemArray.length - 2].id) {
                            limitsCount++;
                        }

                        if (limitsCount > 0 && limitsCount <= 2) {
                            $(_itemSelected).closest("li").addClass('control-list-container selected');
                            let newItem = { id: $(_itemSelected).data('selectedItem'), name: $(_itemSelected).data('selectedName'), key: $(_itemSelected).data('selectedKey') };    
                            newArray.push(newItem);
                        }
                    }
                });

                itemArray = newArray;
            }

            this.model.set('selected', itemArray, { silent: true });
        }else{
            $('.control-list-container.selected').removeClass('control-list-container selected');
            $('a.field-list-toggle').removeClass('selected');
            let _item;
            if (this.model.get('multipleSelectionEnabled')){ //If multiselection enabled then the item must be added in model as an array
                _item = [item]; //At this point multi selection is enabled but the user is not multi selecting items
            }else{
                _item = item;
            }
            //control_row is used only for distinguished rows in the property selectFields,
            //in this case rows musn't be allow to be returned. 
            if(!this.model.get('avoidRows') || selectedKey !== 'control_row' ){
                this.model.set('selected', _item, { silent: true });
            }
            const hideSelectFields = this.model.get('hideSelectFields');    
              
            if (hideSelectFields && (selectedKey === 'control_group' || selectedKey === 'control_radio_button_group')){
                $('#select-field-dialog a.field-list-toggle' + selectedDOMID).last().closest("div").addClass('control-list-container selected');
            }else{
                $('#select-field-dialog ' + selectedDOMID).closest("div").addClass('control-list-container selected');
            }
        }
        
        if( this.model.get("factoryKey") === "command_run")//Run Behavior
        {
            var otherParentToFix = $('a ' + selectedDOMID);
            otherParentToFix = otherParentToFix.closest('li');
            otherParentToFix.removeClass("control-list-container selected");
        }
        if(this.model.get('avoidRows') && selectedKey === 'control_row'){
            $('button.btn-select-field').button("disable");
        }else if (this.target === 'command_set_table_rows') {
            $('button.btn-select-field').button(selectedKey!=='control_table' ? "disable" : "enable");
        } else {
            $('button.btn-select-field').button("enable");
        }
        this.selectParents(selectedDOMID);
    }

    selectParents(selectedDOMID){

        const parents =  $('#select-field-dialog ' + selectedDOMID).parents().filter(".control-list");

        _.each(parents, (list) =>{
            const container = $(list);

            if(container.parent().hasClass("page-list")){ //Is page
                $(list).siblings().addClass("selectedGroup");
            }
            else{//Is group
                $(list).prev().children().addClass("selectedGroup");
            }
            
        });
    }

    bindListEvent() {
        $(constants.SELECT_FIELD_LIST_TOGGLE).on("click", (e)=>{
            const hideSelectFields = this.model.get('hideSelectFields');
            this.showList(e);
            if (hideSelectFields && (e.currentTarget.attributes['data-selected-key'].value === 'control_group' || e.currentTarget.attributes['data-selected-key'].value === 'control_radio_button_group')){
                this.itemClicked(e);  
            }
        });
        $(constants.SELECT_FIELD_ITEM).on("click",(e)=>{
            e.preventDefault();
            this.itemClicked(e);
        });

        $('ul.select-field li.page-list').on("click",(e)=> {
           e.preventDefault();
           let target=$(e.target);
           if((target.prop('tagName') ==='LI') &&
               (target.attr('data-selected-key') !== 'control_group' ||
               target.attr('data-selected-key') !== 'control_drop_down')){
               return;
           }

           if(target.attr('data-selected-key') === 'control_group' ||
              target.attr('data-selected-key') === 'control_drop_down' ||
              target.attr('data-selected-key') === 'control_table' ||
              target.attr('data-selected-key') === 'control_list' ||
              target.attr('data-selected-key') === 'control_ranking' ||
              target.attr('data-selected-key') === 'control_file_attachment' ||
              target.attr('data-selected-key') === 'control_radio_button_group'
           ){

               let targetToWork=$(`ul.control-list.${target.attr('data-target')}`);
               targetToWork.css('padding-left','3.2em');
               targetToWork.children().css('padding-left','0');
           }

            const pageKey = e.currentTarget.children[0].attributes['data-target'].value;

            // PF-3953 Don't flip the toggle if we selected a group label
            if (!(target.attr('data-selected-key') === 'control_group' && !e.target.className.includes('glyph'))) {
                if (e.currentTarget.classList.contains('open-list')) {
                    listService.addSelectFieldExpandedPage(pageKey);
                } else {
                    listService.removeSelectFieldExpandedPage(pageKey);
                }
                this.toggleArrowExpansion(target);
            }
        });
    }

    toggleArrowExpansion(target){
        let spanToWork=$(`span#field-select-${target.attr('data-target')}`);
        spanToWork = spanToWork.length === 0 ? $(`span[data-target="${target.attr('data-target')}"]`) : spanToWork;
        if (spanToWork.hasClass('glyphicon-triangle-bottom')) {
            spanToWork.removeClass('glyphicon glyphicon-triangle-bottom').addClass('glyphicon glyphicon-triangle-right');
        }
        else {
            spanToWork.removeClass('glyphicon glyphicon-triangle-right').addClass('glyphicon glyphicon-triangle-bottom');
        }
    }

    unbindListEvent() {
        $(constants.SELECT_FIELD_LIST_TOGGLE).off();
        $(constants.SELECT_FIELD_ITEM).off();
    }

    getFormBehaviors(){
        listService.behaviorInstances.forEach(behavior => {
            if( behavior.get("ownerId") === "Form"){
                behavior.attributes.isFilter = false;
                behavior.attributes.icon = "";
                behavior.attributes.name = behavior.get("text");
                $('.select-field').append(controlTemplate(behavior.attributes));
            }
        });
    }

    generateList() {
        $('.select-field').empty();
        console.log(`---> model`, this.model);

        var self = this;
        if(this.model.factoryKey === "command_run") //PF-4429
        {
            self.getFormBehaviors();
        }
        
        _.forEach(this.model.get('pages'), function (page) {
           // Page Template
           page.isFilter = false;
            $('.select-field').append(pageTemplate(page));
            self.generateControls(page.id, page.controls);
        });
    }

    seekPrintPagesSelected(){
        let selectedIds = this.model.get("dataSelectedItemId");
        let selected, cleanId;
        
        if (!util.isEmpty(selectedIds)) {
            $('button.btn-select-field').button("enable");

            if (!Array.isArray(selectedIds)) {
                selectedIds = selectedIds.split("|");
            }

            let delay = 20;
            _.each(selectedIds, (attachment, index) => {
                selected = attachment.id || attachment;
                cleanId = listService.cleanId(selected.split(",")[0]);
                let thisNode = $('a[data-target="' + cleanId + '"]');
                if (thisNode && thisNode.length > 0) {
                    setTimeout(() => {
                        thisNode.addClass("selected");
                        thisNode.parent().addClass("selected");  
                    }, delay * (index + 1));               
                }
            });            
        }else{
            $('button.btn-select-field').button("disable");
        }
    }

    openTree(paths, selectedIds){
        const multiSelect = selectedIds.length > 1;
        const self = this;
        this.model.set('manualMultipleSelectionEnabled', multiSelect, {silent:true});

        const scrollToSelectedItem = (currentSelected) =>{
            setTimeout(() => {
                currentSelected[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 500); 
             self.model.set('manualMultipleSelectionEnabled', false, {silent:true});
        }

        //Open tree
        let delay = 20;
        paths.forEach((id, index) => {
            setTimeout(() => {
                let element = $('span[data-target="' + id + '"]');
                element.trigger("click");
            }, delay * (index + 1));
        });

        delay = delay * (paths.length || paths.size + 1);
        //Select current element
        _.each(selectedIds, (selectedId, index) => {
            let thisNode = $('a[data-selected-item="' + selectedId + '"]');

            if (self.mode === "file") {
                const indexOf = selectedId.indexOf("$");
                let cleanId = selectedId.substring(0, indexOf);
                thisNode = $('a[data-selected-item="' + cleanId + '"]');
            }

            if (thisNode && thisNode.length > 0) {
                if (thisNode.length > 1) {
                    thisNode = thisNode.last();
                }
                setTimeout(() => {
                    thisNode.trigger("click");
                    scrollToSelectedItem(thisNode);
                }, delay * (index + 1)); //wait for all of the paths to open first
            }
        });

    }

    seekBehaviorsSelected(){
        let selectedId = this.model.get("dataSelectedItemId");
        let cleanId;
        const paths = new Set();

        if (!util.isEmpty(selectedId)) {
            cleanId = listService.cleanId(selectedId);
            const selectedObj = listService.getBehaviorInstance(cleanId);
            paths.add(selectedObj.get("pageId"));

            let thisNodeId = $('a[data-selected-item="' + cleanId + '"]').last().closest("ul").attr("control-id");

            paths.add(thisNodeId);
            this.openTree(paths, [cleanId]);        
        }
    }

    seekAttachmentsSelected(){
        let selectedIds = this.model.get("dataSelectedItemId");
        let selected = [], cleanId;
        const paths = new Set(); //Use set because there can be more than 1 selection and we don't want to repeat the page

        if (!util.isEmpty(selectedIds)) {

            if (!Array.isArray(selectedIds)) {
                selectedIds = selectedIds.split("|");
            }

            _.each(selectedIds, (attachment, index) => {
                selected[index] = attachment.id || attachment;
                cleanId = listService.cleanId(selected[index]);

                const selectedObj = listService.getObject(cleanId);
                paths.add(selectedObj.pageId);
            })

            this.openTree(paths, selected);
        }
    }

    seekSingleSelectedItem() {
        const self = this;
        let selectedId = self.model.get("dataSelectedItemId");

        if(this.mode === "instance" && typeof selectedId ==="object"){
            selectedId = selectedId.id;
        }        

        if (selectedId) {
            selectedId = listService.cleanId(selectedId);

            let cleanId = selectedId;

            const indexOf = selectedId.indexOf("$");

            if (selectedId && indexOf > -1) {
                cleanId = selectedId.substring(0, indexOf);
            }

            const selectedObj = listService.getObject(cleanId);

            if (selectedObj) {
                const paths = [];

                //Recursive method to get all parents of the selection
                const getPath = (currentSelection) => {
                    const obj = listService.getObject(currentSelection);
                    if (obj) {
                        if (obj.groupId && this.mode !== "insert") {
                            getPath(obj.groupId);
                            paths.push(obj.groupId);
                        }
                        else {
                            paths.push(obj.pageId);
                            if (selectedObj.model.get("factoryKey") === "control_drop_down" ||
                                selectedObj.model.get("factoryKey") === "control_table" ||
                                selectedObj.model.get("factoryKey") === "control_file_attachment") {
                                paths.push(selectedObj.id);
                            }
                        }
                    }
                };
                getPath(cleanId);

                this.openTree(paths, [selectedId]);
            }
        }
    }

    generateControls(parentId, controls) {
        var self = this;
        var parentDOMSelector = '#select-field-dialog ul.control-list.' + parentId;
        var origin = this.target;
        const hideSelectFields = util.isTrue(this.model.get('hideSelectFields'));
        _.forEach(controls, function(control) {
            control.hideSelectFields = hideSelectFields;
            control.isGroupWithRadioButtons = false;
            control.isGroup = false;
            control.isFilter = false;
            control.iconSize = control.factoryKey === 'control_checkbox' || control.factoryKey === 'control_radio_button' ? "15px" : "20px";
            if (control.factoryKey === 'control_group'){
                control.isGroup = true;
                control.isGroupWithRadioButtons = _.find(control.controls,{'factoryKey':'control_radio_button'}) ? true : false;
            }            
            if (control.controls && control.controls.length > 0) {       
                
                //PF-8384 If check mandatory the Value and Caption option should not be displayed for radio button groups
                if(self.model.get('factoryKey') === "command_check_obligatory"){
                    control.hideSelectFields = true;
                }
                $(parentDOMSelector).append(controlWithValuesTemplate(control));
                self.generateControls(control.id, control.controls);
            } else {
                if ((control.selectFields && !hideSelectFields) && (self.mode !== 'insert' && self.mode !== 'lists' && self.mode !== 'objectsANDlists') && origin !== 'command_show')
                {
                    $(parentDOMSelector).append(controlWithValuesTemplate(control));
                } else {
                    if ((self.model.get('factoryKey') === "command_check_obligatory" || self.model.get('factoryKey') === "command_set_properties")  && control.factoryKey === 'control_table'){
                        if(self.model.get('avoidRows') && control.factoryKey === 'control_table' ){
                            control.selectFields = self.cleanRows(control);
                        }
                        $(parentDOMSelector).append(controlWithValuesTemplate(control)); 
                    }
                    else{
                     $(parentDOMSelector).append(controlTemplate(control));
                    }
                }
            }

        });
    }

    //If the rows are not allow to be returned with need to show them in an especial format according with flash
    cleanRows(control){ 
      return control.selectFields.filter(row => row.text.includes("All Rows"))
            .map(function(r) { 
                let obj = {};
                obj.text = r.text.replace(' -  All Rows',''); 
                obj.id = r.id;
                return obj;
            });
    }

    afterRender(){
        let self = this;
        let pageTriangles = $(constants.SELECT_FIELD_ID).find("span.glyphicon");
        
        if(self.mode && self.mode === "print")
        {
            pageTriangles.hide();
        }
        else
        {
            pageTriangles.show();
            pageTriangles.each(function(){
                let currentElement=$(this);
                let dataTarget = currentElement.attr('data-target');
                let elementToWork=$(constants.SELECT_FIELD_ID ).find(`ul.control-list.${dataTarget}`);
                if((elementToWork).is(":visible")){
                    currentElement.removeClass('glyphicon glyphicon-triangle-bottom glyphicon-triangle-right').addClass('glyphicon glyphicon-triangle-bottom');
                }
                else{
                    currentElement.removeClass('glyphicon glyphicon-triangle-bottom glyphicon-triangle-right').addClass('glyphicon glyphicon-triangle-right');
                }
            });
        }
    }

    render() {
        let self = this;
        return new Promise((resolve, reject) => {
            this.$el.empty();
            if(this.template) {
                this.$el.html(template(this.model.toJSON()));
            }
            $('body').append(this.$el);
            listService.isUndoRedoEnabled = false;

            // Show modal popup window
            this.dialog = $( constants.SELECT_FIELD_ID ).dialog({
                dialogClass: this.dialogClass,
                autoOpen: true,
                height: 400,
                minHeight: 200,
                width: 400,
                minWidth: 250,
                modal: true,
                resizable: true,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            self.closeModal();
                            let selected = this.model.get('selected');
                            if (self.target === 'command_set_table_rows') {
                                if (this.model.get('multipleSelectionEnabled')) {
                                    selected.each(function (idx, item) {
                                        if (item.key === 'control_table') {
                                            eventBus.trigger('getColumnsOfSelectedTable', listService.getObject(listService.cleanId(item.id)));
                                        }
                                    });
                                } else {
                                    eventBus.trigger('getColumnsOfSelectedTable', listService.getObject(listService.cleanId(selected.id)));
                                }
                            }
                            resolve(selected);
                        }
                    },
                    {
                        text: 'Cancel',
                        'class':'btn-addAssetCancel',
                        click: () => {
                            $('button.btn-select-field').button("enable");
                            self.closeModal();
                        }
                    }
                ],
                close: () => {
                    this.unbindListEvent();
                    this.dialog.dialog("destroy");
                    this.closeModal();
                    this.dialog.remove();
                },
                open: () =>{
                    this.generateList();
                    this.bindListEvent();
                    $( constants.SELECT_FIELD_ID ).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                }
            });
            
            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

            switch(this.mode){
                case "insert":
                    this.seekAttachmentsSelected();
                break;
                case "print":
                    this.seekPrintPagesSelected();
                break;
                case "behaviors":
                    this.seekBehaviorsSelected();
                break;
                default:
                    this.seekSingleSelectedItem();
                    break;
            }

            this.afterRender();

            this.delegateEvents();
            return this;
        });
    }

}

export default SelectFieldModalView;
